import { makeAutoObservable, runInAction } from "mobx";
import http from "../services/http";

export interface IFeaturePrice {
  id: string;
  feature: {
    code: string;
    title: string;
    description?: string;
    unit?: string;
    type?: string;
  } | null;
  price: number;
  oldPrice?: number | null;
  priceYear: number | null;
  oldPriceYear?: number | null;
}

class FeaturePriceStore {
  data: IFeaturePrice[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchAll() {
    this.isLoading = true;

    try {
      const res = await http.get("/feature-prices");

      runInAction(() => {
        this.data = res.data.data;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default new FeaturePriceStore();
